import React from 'react';
import { Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

import Routes from './routes';
import { store, persistor } from './store';
import history from './services/history';

import NavBar from './layout/NavBar';
import Header from './layout/Header';
import Footer from './layout/Footer';

import './App.scss';

const App = () => {
  return (
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <Router history={history}>
          <NavBar />
          <Header />
          <section className="section">
            <div className="container">
              <Routes />
            </div>
          </section>
          <Footer />
        </Router>
      </PersistGate>
    </Provider>
  );
};

export default App;
